import type {
  TemplateTraditionalProps,
  TemplateTraditionalXinglet,
} from '@xing-com/crate-lebenslauf-xinglets';

import { Traditional } from './traditional';

export default class TemplateTraditional implements TemplateTraditionalXinglet {
  public getComponent() {
    return (props: TemplateTraditionalProps): JSX.Element => (
      <Traditional {...props} />
    );
  }
}
